module.exports = __webpack_public_path__ + "img/status-11.c51ce524.png";